import { AccountLabel } from "@/entities/Labeling/Account.model";
import { MetricQuery, WindowOperation } from "./metrics.types";

export function serializeMetricQuery(
    query: Omit<MetricQuery, "metricQuery">,
): string {
    let metricQueryString = `${query.metric}-${query.periodResolution}`;

    if (query.window && query.window.size >= 1 && query.window.size <= 255) {
        const windowPrefix = query.window.applyLast ? "W" : "w";
        metricQueryString += `-${windowPrefix}${query.window.size}${query.window.operation}`;
    }

    return metricQueryString;
}

export function parseMetricQuery(
    queryString: string | null | undefined,
): MetricQuery {
    const defaultQuery: MetricQuery = {
        metric: AccountLabel.REVENUES,
        periodResolution: "y",
        metricQuery: `${AccountLabel.REVENUES}-y`,
    };

    if (!queryString) {
        return defaultQuery;
    }

    const parts = queryString.split("-");

    if (parts.length < 2) {
        return defaultQuery;
    }

    const metric = parts[0] as AccountLabel;
    const periodResolution = parts[1] as "m" | "q" | "y";

    if (!Object.values(AccountLabel).includes(metric)) {
        return defaultQuery;
    }

    if (!["m", "q", "y"].includes(periodResolution)) {
        return defaultQuery;
    }

    const result: MetricQuery = {
        metric,
        periodResolution,
        metricQuery: queryString,
    };

    if (parts.length >= 3) {
        const windowPart = parts[2];
        const applyLast = windowPart.startsWith("W");
        const windowContent = applyLast
            ? windowPart.slice(1)
            : windowPart.slice(1);

        const operationMatch = windowContent.match(/^(\d+)(.+)$/);
        if (operationMatch) {
            const size = parseInt(operationMatch[1], 10);
            const operation = operationMatch[2] as WindowOperation;

            if (
                size >= 1 &&
                size <= 255 &&
                Object.values(WindowOperation).includes(operation)
            ) {
                result.window = {
                    size,
                    applyLast,
                    operation,
                };
            }
        }
    }

    return result;
}
